// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hAXo","clinicsSelect":"styles_clinicsSelect__1wzt6"};